<template>
  <div v-if="fetched" class="wrapper">
    <div v-if="!errored" class="container">
      <!-- バナー -->
      <div class="banner">
        <img :src="furnitureGachaBannerURL" />
      </div>
      <div class="cancellationCautionText">
        {{ $t('furniture_gacha_rates__caption__image_caution') }}
      </div>
      <div class="content">
        <!-- テーブル -->
        <div v-if="!loading">
          <table class="furnitureGachaContentList">
            <tbody>
              <template v-for="(furnitureGachaItemViewRarity, i) in furnitureGachaItemsRarity">
                <!-- レア度ヘッダー -->
                <tr :key="i" class="rarityHeader">
                  <td colspan="3" class="rarityHeaderStar">
                    <img
                      v-for="star in furnitureGachaItemViewRarity.rarity"
                      :key="star"
                      src="/img/rarity-star.png"
                      width="16px"
                      height="16px"
                    />
                  </td>
                  <td class="rarityHeaderTotalEmissionRate">
                    {{
                      furnitureGachaRarityRateMap[furnitureGachaItemViewRarity.rarity].toFixed(2)
                    }}%
                  </td>
                </tr>
                <!-- アイテムテーブル -->
                <template>
                  <tr
                    v-for="(furnitureGachaItem, k) in furnitureGachaItemViewRarity.furnitureGachaItemView"
                    :key="furnitureGachaItem.itemId"
                    :class="{
                      furnitureGachaContent: true,
                      furnitureGachaContentBorder: k != furnitureGachaItemViewRarity.furnitureGachaItemView.length - 1,
                    }"
                  >
                    <!-- サムネ -->
                    <td class="thumbnail">
                      <img
                        :src="furnitureGachaItem.bannerUrl"
                      />
                    </td>
                    <!-- アイテム名 -->
                    <td class="name">
                      {{ furnitureGachaItem.name }}
                    </td>
                    <!-- 排出率 -->
                    <td 
                      class="emissionRate">
                      {{ furnitureGachaItem.emissionRate.toFixed(2) }}%
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
          <ul v-if="!this.loading" class="caution">
            <li>{{ $t('furnitureGachaDesc1') }}</li>
            <li>{{ $t('furnitureGachaDesc2') }}</li>
            <li>{{ $t('furnitureGachaDesc9') }}</li>
            <li>{{ $t('furnitureGachaDesc4') }}</li>
            <li>{{ $t('furnitureGachaDesc5') }}</li>
            <li>{{ $t('furnitureGachaDesc6') }}</li>
            <li>{{ $t('furnitureGachaDesc7') }}</li>
            <li>{{ $t('furnitureGachaDesc8') }}</li>
            <li v-if="new Date() >= new Date('2026-11-01T00:00:00+09:00')">{{ $t('furnitureGachaDesc10') }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import 'reflect-metadata'
import { Component, Mixins } from 'vue-property-decorator'
import {
  ApiFurnitureGachaItemEmissionRate,
} from '../../api/schema/appGatewayServer'
import { Route } from 'vue-router'
import i18n from '@/i18n'
import { LanguageQueryHandler } from '@/mixins/LanguageQuery'
import { apiV2 } from '@/api/appGatewayServerV2Api'

interface FurnitureGachaItemViewTotalRarity {
  furnitureGachaItemView: ApiFurnitureGachaItemEmissionRate[]
  rarity: number
}

@Component({
  title: i18n.t('furnitureGachaOdds'),
} as any)
export default class FurnitureGachaOdds extends Mixins(LanguageQueryHandler) {
  furnitureGachaId: number = 0

  fetched = false
  errored = false
  furnitureGachaBannerURL: string = ""
  furnitureGachaItems: ApiFurnitureGachaItemEmissionRate[] = []
  furnitureGachaItemsRarityMap: { [key: number]: FurnitureGachaItemViewTotalRarity } = {}
  furnitureGachaItemsRarity: FurnitureGachaItemViewTotalRarity[] = []
  furnitureGachaRarityRateMap: { [key: number]: number } = {}

  $route!: Route
  $t!: any

  loading: boolean = true

  private async mounted() {
    this.furnitureGachaId = Number(this.$route.params.furnitureGachaId)

    try {
      await this.fetchFurnitureGachaItems()
      this.loading = false
    } catch (error) {
      this.errored = true
    } finally {
      this.fetched = true
    }
  }

  private async fetchFurnitureGachaItems() {
    const itemResponse = await apiV2().furnitureGacha.getItemList({
      furnitureGachaId: this.furnitureGachaId,
    })

    this.furnitureGachaBannerURL = itemResponse.bannerUrl

    // レアリティレートを取り出す
    itemResponse.furnitureGachaRarityList.forEach((furnitureGachaRarityRate) => {
      this.furnitureGachaRarityRateMap[furnitureGachaRarityRate.rarity] =
        furnitureGachaRarityRate.emissionRate
    })

    // アイテム一覧を取り出す
    this.furnitureGachaItems = itemResponse.furnitureGachaItemList

    // レア度ごとにまとめる
    this.furnitureGachaItems.forEach((furnitureGachaItem) => {
      var rarity = furnitureGachaItem.rarity
      if (this.furnitureGachaItemsRarityMap[rarity] === undefined) {
        this.furnitureGachaItemsRarityMap[rarity] = {
          furnitureGachaItemView: [],
          rarity: 0,
        }
      }
      this.furnitureGachaItemsRarityMap[rarity].furnitureGachaItemView.push(furnitureGachaItem)
      this.furnitureGachaItemsRarityMap[rarity].rarity = rarity
    })

    // レア度でソート
    this.furnitureGachaItemsRarity = Object.keys(this.furnitureGachaItemsRarityMap)
      .map((rarity) => {
        var key = parseInt(rarity)
        return this.furnitureGachaItemsRarityMap[key]
      })
      .sort((a, b) => {
        return b.rarity - a.rarity
      })
  }
}
</script>

<style scoped>
.wrapper {
  background: #f8f8f8;
  min-height: 100%;
}

.container {
  max-width: 500px;
  margin: 0 auto;
  padding: 0 0 var(--safe-area-inset-bottom, 0px) 0;
  background: #fff;
}

.banner {
  width: 100%;
}

.banner p {
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  border-radius: 0px 0px 4px 0px;
  margin: 0 0 0 0;
  padding: 2px 8px;
  background-color: #ff003d;
  color: #ffffff;
}

.banner img {
  width: 100%;
  text-align: center;
  vertical-align: bottom;
  background-color: #ff003d;
}

.origin {
  position: relative;
}

.origin p {
  position: absolute;
  right: 0;
  bottom: 0;
  margin-right: 8px;
  margin-bottom: 8px;
  padding: 2px 8px;
  border-radius: 4px;
  background: rgba(38, 38, 38, 0.6);
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-align: center;
  color: #ffffff;
}

.cancellationCautionText {
  padding: 4px 16px 8px 16px;
  text-align: center;
  font-size: 10px;
  line-height: 16px;
  color: #bababa;
}

.furnitureGachaContentList {
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  border-collapse: collapse;
}

.furnitureGachaContentHeader {
  text-align: left;
  font-size: 0.9rem;
  line-height: 2.3rem;
}

.rarityHeader {
  width: 100%;
  height: 32px;
  text-align: center;
  background-color: #f6f6f6;
  vertical-align: middle;
}

.rarityHeaderStar {
  text-align: left;
  padding: 4px 0px 7px 16px;
}

.rarityHeaderStar img {
  padding-right: 4px;
}

.rarityHeaderTotalEmissionRate {
  text-align: right;
  vertical-align: middle;
  line-height: 16px;
  font-size: 12px;
  display: inline-block;
  padding: 10px 16px 8px 8px;
  width: 100%;
}

.furnitureGachaContent {
  margin: 0px 0px 0px 0px;
}

.furnitureGachaContentBorder {
  border-bottom: 1px solid #e8e8e8;
}

.thumbnail {
  width: 44px;
  height: 72px;
  padding-left: 16px;
}

.thumbnail img {
  width: 44px;
  height: 44px;
}

.name {
  width: 300px;
  font-size: 12px;
  overflow-wrap: break-word;
  padding-left: 12px;
}

.emissionRate {
  width: 68px;
  line-height: 16px;
  font-size: 12px;
  text-align: center;
  padding-right: 16px;
}

.color {
  text-align: center;
}

.caution {
  margin: 1rem auto;
  font-size: 12px;
  list-style: none;
  padding: 0 16px 0 24px;
}

.caution li:before {
  content: '＊';
  margin-left: -1em;
  color: #808080;
}

.tabGroupContent {
  height: 40px;
  max-width: 500px;
  margin: 0 auto;
  overflow: scroll;
  white-space: nowrap;
}

.tabGroupContent::-webkit-scrollbar {
  display: none;
}

.tabGroup {
  line-height: 40px;
  display: inline-block;
  height: 40px;
  font-size: 14px;
  color: #000;
  text-align: center;
}

.tabWeight {
  width: 100%;
  height: 40px;
  padding: 0px 8px 0px 8px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #bababa;
  flex: none;
  order: 0;
  flex-grow: 0;
  background-color: Transparent;
  border: none;
  border-bottom: 3px solid transparent;
}

.tabSelectedWeight {
  width: 100%;
  height: 40px;
  padding: 0px 8px 0px 8px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #188dff;
  flex: none;
  order: 0;
  flex-grow: 0;
  background-color: Transparent;
  border: none;
  border-bottom: 3px solid;
}
</style>
